// Sidebar sections based on the order of this object

// eslint-disable-next-line import/prefer-default-export
export const SECTIONS = {
  foundations: "Foundations",
  guides: "Guides",
  patterns: "Patterns",
  components: "Components",
};
